import components_plugin_KR1HBZs4kY from "D:/oneway/machine-web/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_zq0dpLPQya from "D:/oneway/machine-web/node_modules/.pnpm/nuxt@3.2.2_stylus@0.59.0/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_liPNsMvgrv from "D:/oneway/machine-web/node_modules/.pnpm/nuxt@3.2.2_stylus@0.59.0/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_lmBXJqxLVu from "D:/oneway/machine-web/node_modules/.pnpm/nuxt@3.2.2_stylus@0.59.0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import element_plus_teleports_plugin_h4Dmekbj62 from "D:/oneway/machine-web/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "D:/oneway/machine-web/.nuxt/element-plus-injection.plugin.mjs";
import payload_client_DvB9ggJWFW from "D:/oneway/machine-web/node_modules/.pnpm/nuxt@3.2.2_stylus@0.59.0/node_modules/nuxt/dist/app/plugins/payload.client.mjs";
export default [
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_zq0dpLPQya,
  router_liPNsMvgrv,
  prefetch_client_lmBXJqxLVu,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  payload_client_DvB9ggJWFW
]